/* eslint-disable no-underscore-dangle */
export default class StickyObserver {
	constructor({ elements }) {
		this._elements = elements;
		this._stickyElement = document.querySelector('.call-to-action--sticky');
		this._rootMargin = this._elements[0].rootMargin || '0px 0px 100px';

		if (this._elements.length && this._stickyElement) {
			const observer = new IntersectionObserver(
				(entries) => {
					// Check if at least one CTA is visible
					const anyPartiallyVisible = entries.some((entry) => entry.intersectionRatio > 0);

					// Sticky CTA should appear only when no CTA is visible at all
					if (!anyPartiallyVisible) {
						this._stickyElement.classList.add('show');
					} else {
						this._stickyElement.classList.remove('show');
					}
				},
				{
					rootMargin: this._rootMargin,
					threshold: [0], // Detects when even a tiny part of the element appears
				}
			);

			// Observe all CTA elements
			this._elements.forEach((element) => observer.observe(element));
		}
	}
}
